var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0.5H18.25V5.5H16.25V2.5H12.25V0.5ZM6.25 0.5V2.5H2.25V5.5H0.25V0.5H6.25ZM12.25 18.5V16.5H16.25V13.5H18.25V18.5H12.25ZM6.25 18.5H0.25V13.5H2.25V16.5H6.25V18.5ZM0.25 8.5H18.25V10.5H0.25V8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanIcon);
export default __webpack_public_path__ + "static/media/scanIcon.80455f74ea83f790c0512ef8db9c066b.svg";
export { ForwardRef as ReactComponent };